import { defineStore } from 'pinia';
import { useSelectOptionStore } from './selectoption';
import { useRelatedStore } from './related';
import { useTokenStore } from './token';
import { useWebsiteStore } from './website';
import { useOfferGroupStore } from './offergroup';
import { useOfferFormStore } from './offerform';
import { useOfferSearchStore } from './offersearch';
import { useUploadStore } from './upload';
import { useBatchStore } from './batch';
import { useRequestManagementStore } from './request-mgmt';
import { useActivationOfferStore } from './activationoffer';
import { useMessagingStore } from './messaging';
import { useRequestInitStore } from './request-init';
import type { EAV, Search } from '@fibl/zdb-common';
import { useTemporaryUploadStore } from './temporary-upload';
import { useMailerStore } from './mailer';
import { useUserListStore } from './userlist';
import { useBbayStore } from './bbay';
import { useMenuStore } from './menu';
import { useOfferListStore } from './offerlist';
import { useClassificationMonitorStore } from './classification-monitor';
import { useExportStore } from './export';
import { useETLStore } from './etl';

export const useGlobalStore = defineStore('global', {
	state: () => ({
		maintenance: false,
		batchStore: useBatchStore(),
		exportStore: useExportStore(),
		etlStore: useETLStore(),
		uploadStore: useUploadStore(),
		offerformStore: useOfferFormStore(),
		offergroupStore: useOfferGroupStore(),
		offerSearchStore: useOfferSearchStore(),
		relatedStore: useRelatedStore(),
		requestManagement: useRequestManagementStore(),
		requestInit: useRequestInitStore(),
		selectOptionStore: useSelectOptionStore(),
		tokenStore: useTokenStore(),
		websiteStore: useWebsiteStore(),
		messagingStore: useMessagingStore(),
		activationOfferStore: useActivationOfferStore(),
		temporaryUploadStore: useTemporaryUploadStore(),
		mailerStore: useMailerStore(),
		useUserListStore: useUserListStore(),
		bbayStore: useBbayStore(),
		menuStore: useMenuStore(),
		offerlistStore: useOfferListStore(),
		classificationMonitorStore: useClassificationMonitorStore(),
	}),
});
